<template>
    <div>
        <CoachRequests></CoachRequests>
        <!-- <PromoGif></PromoGif> -->
        <gif></gif>
        <div class=" top_bar_holder">
          <div class="row">
            <!-- col-md-6 col-lg-4 col-sm-12 col-lg-4 col-xl-4 d-none d-sm-block d-sm-none d-md-block   -->
            <div
              class="d-none d-lg-block col-lg-4"
            >
              <div>
                <p class="top_bar_payrent">
                  Rent Requests
                  <img src="../assets/images/white-arrow.svg" alt="forward" />
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-4 col-sm-12 col-lg-4 col-xl-4 mb-3 mb-md-0"
            >
              <div class="existing_prop_btn">
                <button class="btn" @click="topNavigation(1)">
                  <img src="../assets/images/renewalicon.svg" alt="renew" />
                  Guarantee Rent Request
                </button>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-12 col-lg-4 col-xl-4">
              <div class="add_prop_rentfinancing_btn">
                <button class="btn" @click="topNavigation(2)">
                  <!-- <img src="../assets/images/addwhite-icon.svg" alt="add" /> -->
                  Add New Property (rent)
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="top_bar">
            <div>
              <p>
                Pay My Rent
                <img src="../assets/images/white-arrow.svg" alt="forward" />
              </p>
            </div>
            <button class="btn" @click="topNavigation(1)">
              <img src="../assets/images/renewalicon.svg" alt="renew" />
              Existing Property & Rent Renewals
            </button>
            <button class="btn" @click="topNavigation(2)">
              <img src="../assets/images/addwhite-icon.svg" alt="add" />
              Add New Property (Rent Financing)
            </button>
          </div> -->
        </div>

        <!-- Countdown for guarantee rent -->
        <section class="notifications-grid" style="margin-left: 15px; margin-right: 15px;" v-if="computedRentals">
            <div
                class="rental-card"
                :class="{ 'urgent-card': computedRentals && computedRentals.isUrgent }"
            >
                <!-- Left: Circular Countdown -->
                <div class="progress-wrapper">
                <svg class="progress-ring" width="72" height="72">
                    <circle
                    class="progress-ring__bg"
                    stroke="#e2e8f0"
                    stroke-width="5"
                    fill="transparent"
                    r="31"
                    cx="36"
                    cy="36"
                    />
                    <circle
                    class="progress-ring__bar"
                    :class="{ 'bar-urgent': computedRentals && computedRentals.isUrgent }"
                    stroke="#2563eb"
                    stroke-width="5"
                    fill="transparent"
                    r="31"
                    cx="36"
                    cy="36"
                    :stroke-dasharray="2 * Math.PI * 31"
                    :stroke-dashoffset="computedRentals && computedRentals.strokeOffset"
                    />
                </svg>
                <div class="counter-text">
                    <span class="days-number">{{ padZero(computedRentals && computedRentals.displayValue) }}</span>
                    <span class="days-label">{{ computedRentals && computedRentals.displayUnit }}</span>
                </div>
                </div>

                <!-- Center: Text Details -->
                <div class="card-content">
                <h2 class="card-title">{{ computedRentals && computedRentals.title}}</h2>
                <h2 class="card-title" style="font-size: 14px;">{{ nearest_tenant_rent.firstname }} {{ nearest_tenant_rent.lastname }}</h2>
                <p class="card-address" :title="nearest_tenant_rent.address">{{ nearest_tenant_rent.address }}</p>
                </div>

                <!-- Right: Status Badge & Close Actions -->
                <div class="card-actions">
                <!-- <button class="close-btn" @click="dismissCard(item.id)" aria-label="Dismiss">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 1L13 13M13 1L1 13" stroke="#475569" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button> -->
                <span class="status-percentage">{{ guaranteeRent.percentage }}%</span>
                </div>
            </div>
        </section>

        <!-- Countdown for guarantee rent ends -->

        <div class="holder">
            <div v-if="pageLoader">
                <PageLoader></PageLoader>
            </div>
            <div v-else class="dashboard-holder">
                <!-- <SmallNav /> -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="card-cover">
                                <div class="headerss">
                                    <div class="top-card">
                                        <h5>My Property</h5>
                                        <h6>Here are the details of your property and project overview</h6>
                                    </div>
                                    <!-- <div class="add-prop-btn" @click="navigatiionRoutes('/addproperty')">
                                        <button class="btn"><span>+</span> Add Property (rent)</button>
                                    </div> -->
                                </div>
                                <div class="dashboard-count">
                                    <div class="row">
                                        <!-- col-sm-12 -->
                                        <div class="col-md-3">
                                            <img src="../assets/icons/house-persons.svg" alt="tenants">
                                            <h6><span>{{ newDasboard.data.number_of_tenants}}</span> Tenant</h6>
                                        </div>
                                        <div class="col-md-3">
                                            <img src="../assets/icons/schedule-time.svg" alt="tenants">
                                            <h6><span>{{ newDasboard.data.pending_rent}}</span> Pending Rent</h6>
                                        </div>
                                        <div class="col-md-3">
                                            <img src="../assets/icons/hand-raised.svg" alt="tenants">
                                            <h6><span>{{ newDasboard.data.maintenance_requests}}</span> Request</h6>
                                        </div>
                                        <div style="cursor: pointer;" class="col-md-3" @click="navigatiionRoutes('/dashboard/safeprojects')">
                                            <img src="../assets/icons/blue-house.svg" alt="tenants">
                                            <h6><span>{{ newDasboard.data.projects_count}}</span> Projects</h6>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="safe-card mb-3">
                                        <div class="safe-card-top">
                                            <div class="" style="display: flex; gap: 10px;">
                                                <img src="../assets/icons/safe-logo-black.svg" alt="safe">
                                                <h3>SAFE</h3>
                                            </div>
                                            <div class="dropdown">
                                                <div  data-toggle="dropdown" aria-expanded="false" class="">
                                                    <span class="" style="cursor: pointer;"><i class="fa fa-ellipsis-h"></i></span>
                                                    <!-- <p>.</p><p>.</p><p>.</p> -->

                                                    
                                                </div>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" v-if="whichSafe == 'blueSafe'" data-toggle="modal" data-target="#fundbluesafe">Fund Safe</a>
                                                    <!-- && (safeDetails.safedata.squadaccountno == null && safeDetails.safedata.firstBankaccountNumber == null) -->
                                                    <!-- <a class="dropdown-item" v-if="whichSafe != 'blueSafe' && (safeDetails.safedata.squadaccountno == null && safeDetails.safedata.firstBankaccountNumber == null)" data-toggle="modal" data-target="#upgradesafe">Upgrade Account</a> -->
                                                    <a class="dropdown-item" v-if="(safeDetails.safedata.squadaccountno == null || safeDetails.safedata.firstBankaccountNumber == null)" data-toggle="modal" data-target="#upgradesafe">Upgrade/add Account</a>
                                                    <!-- <a class="dropdown-item" data-toggle="modal" data-target="#upgradesafe" v-if="safeDetails.safedata.squadaccountno == null || safeDetails.safedata.firstBankaccountNumber == null">Upgrade Account</a> -->
                                                    <a class="dropdown-item" @click="navigatiionRoutes('/dashboard/autodebit')">Auto fund</a>
                                                    <!-- :disabled="projects.length == 0" -->
                                                    <a class="dropdown-item"
                                                      data-toggle="modal"
                                                      data-target="#fundproject">
                                                      Fund project
                                                    </a>
                                                    <!-- <a class="dropdown-item" href="#">Auto debit</a> -->
                                                    <a class="dropdown-item" @click="widthdrawFromSafeTrigger()">Withdraw funds</a>
                                                    <!-- <a class="dropdown-item" @click="navigatiionRoutes('/dashboard/safe')">Add another bank</a> -->
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <p class="af">Available funds</p>

                                        <div class="safe-amount">
                                            <div class>
                                                <h3><small v-if="amountVisibility">₦</small>{{ amountVisibility ? Number(safeDetails.balance).toLocaleString() : '**************'}}  <span>0.00%</span> <span><i class="fa fa-arrow-up"></i></span></h3>
                                                <p v-if="newDasboard.data.safe_last_funded != null">last funded: <span>{{  newDasboard.data.safe_last_funded.created_at | moment }}</span></p>
                                            </div>
                                            <div>
                                                <span @click="amountVisibility = !amountVisibility"><i class="fa" style="cursor: pointer;" :class="[amountVisibility ? 'fa-eye-slash' : 'fa-eye']"></i></span>
                                            </div>
                                        </div>

                                        <div class="bank-details">
                                            <div class="account-number" v-if="(safeDetails.safedata.squadaccountno != null && safeDetails.safedata.firstBankaccountNumber == null) || (safeDetails.safedata.squadaccountno == null && safeDetails.safedata.firstBankaccountNumber != null)">
                                            <!-- <div class="account-number" v-if="currentAccountDetails.squadaccountno != null && currentAccountDetails.firstBankaccountNumber != null"> -->
                                                <img v-if="currentAccountDetails.bank_name == 'gtb'" src="../assets/icons/banks-logo.svg" alt="bank">
                                                <img style="width: 36px;"  v-if="currentAccountDetails.bank_name == 'fbn'" src="../assets/icons/fbn-logo.svg" alt="bank">
                                                <div>
                                                    <p v-if="currentAccountDetails.bank_name == 'gtb'">GT Bank</p>
                                                    <p v-if="currentAccountDetails.bank_name == 'fbn'">First Bank</p>
                                                    <h5>{{ currentAccountDetails.account_number }} <span @click="copyAccountNumber(currentAccountDetails.account_number)"><img class="pl-2" style="cursor: pointer;" src="../assets/icons/bx-copy.svg" alt="copy"></span></h5>
                                                    <!-- <p v-if="switchAccountInfo.bank_name == 'gtb'">GT Bank</p>
                                                    <p v-if="switchAccountInfo.bank_name == 'fbn'">First Bank</p>
                                                    <h5>{{ switchAccountInfo.account_number }} <span @click="copyAccountNumber(switchAccountInfo.account_number)"><img class="pl-2" style="cursor: pointer;" src="../assets/icons/bx-copy.svg" alt="copy"></span></h5> -->
                                                </div>
                                            </div>
                                            <div>
                                                <button class="btn white-outline-btn">
                                                    <router-link to="/dashboard/safe">View more</router-link>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="safe-card mb-3">
                                        <div class="safe-card-top">
                                            <div class="">
                                                <h3>Shelta reward</h3>
                                            </div>
                                        </div>
                                        <p class="af">You've earned {{Number(newDasboard.data.today_rewards).toLocaleString()}} points today</p>

                                        <div class="safe-amount">
                                            <div class>
                                               
                                                <h3>{{ rewardVisibility ? Number(newDasboard.data.shelta_points).toLocaleString() : '**************'}}  <span>{{(newDasboard.data.percentage_increase.toFixed(2))}}%</span> <span><i class="fa fa-arrow-up"></i></span></h3>
                                                <!-- <p>You've earned {{newDasboard.data.today_reward}} points today</p> -->
                                            </div>
                                            <div>
                                                <span @click="rewardVisibility = !rewardVisibility"><i class="fa fa-eye"></i></span>
                                            </div>
                                        </div>

                                        <div class="bank-details" style="margin-top: 40px;">
                                            <div class="account-number">
                                                <div>
                                                    <button disabled class="btn white-outline-btn">
                                                        <!-- <router-link to="/dashboard/sheltareward">
                                                            View more
                                                        </router-link> -->
                                                        View more
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                            <div>
                                                <button disabled class="btn primaryBtn">Earn points</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="projects-list-holder card-cover">
                                <div class="headerss">
                                    <div class="top-card">
                                        <h5>My Projects</h5>
                                        <h6>Here are the details of your project </h6>
                                    </div>
                                    <div class="add-prop-btn">
                                        <button @click="navigatiionRoutes('/dashboard/newproject')" class="btn"><span>+</span> Add Project</button>
                                    </div>
                                </div>

                                

                                <div v-if="projects.length > 0" class="project-holder">
                                    <div class="project-list" v-for="(item, index) in projects.slice(0, 3)"
                                        :key="index">
                                        <div class="d-flex align-items-center" style="gap: 10px;">
                                            <div class="project-dot"></div>
                                            <div>
                                                <h5>{{ item.title }}</h5>
                                                <h6><span>ED:</span> {{item.enddate | moment}} | {{item.daysleft}}d Left</h6>
                                            </div>
                                        </div>
                                        <div style="text-align: left;">
                                            <h5>₦{{ Number(item.amountleft).toLocaleString()}} </h5>
                                            <h6 v-if="item.amounttype === 'fixed'">Goal: ₦{{ Number(item.amountforfixed).toLocaleString()}}</h6>
                                            <h6 v-if="item.amounttype === 'range'">Goal: ₦{{ Number(item.amountforfixed).toLocaleString()}}</h6>
                                            <small v-if="item.PI == '' || item.PI == null">PI: 0% </small>
                                            <small v-else>PI: {{ item.PI }}%</small>
                                        </div>
                                    </div>
                                    <!-- <div class="project-list">
                                        <div class="d-flex align-items-center" style="gap: 10px;">
                                            <div class="project-dot"></div>
                                            <div>
                                                <h5>Alternate power supply</h5>
                                                <h6><span>ED:</span> May 12, 2023 | 72d Left</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <h5>₦100,000,000,000 </h5>
                                            <h6>Goal: ₦100,000,000,000</h6>
                                            <small>PI: 23%</small>
                                        </div>
                                    </div>
                                    <div class="project-list">
                                        <div class="d-flex align-items-center" style="gap: 10px;">
                                            <div class="project-dot"></div>
                                            <div>
                                                <h5>Alternate power supply</h5>
                                                <h6><span>ED:</span> May 12, 2023 | 72d Left</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <h5>₦100,000,000,000 </h5>
                                            <h6>Goal: ₦100,000,000,000</h6>
                                            <small>PI: 23%</small>
                                        </div>
                                    </div> -->
                                    <p class="viewall" @click="navigatiionRoutes('/dashboard/safeprojects')">View All</p>
                                </div>

                                <div v-else class="empty-state mt-5 mb-5">
                                    <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                    <h5>No available data</h5>
                                </div>
                            </div> 
                            
                            <div class="mb-3 mt-3 card-cover d-none">
                                <div class="top-card">
                                    <h5>Total rent payment status</h5>
                                </div>

                                <div class="chart-buttons">
                                    <div class="duration-button">
                                        <button class="btn active-duration">Monthly</button>
                                        <button class="btn">Yearly</button>
                                    </div>
                                    <div class="report-btns">
                                        <button class="btn report">View full report</button>
                                        <button class="btn request">Request rent</button>
                                    </div>
                                </div>
                                <apexchart
                                    type="bar"
                                    height="350"
                                    :options="chartOptions"
                                    :series="series"
                                />

                                <div class="chart-spans">
                                    <span>April income rent : <span class="light-span">Goal: ₦450,000</span></span>  <span>Upcoming Payment : <span class="light-span">₦58,000</span></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            
                            <div class="right-cards">
                                <div class="mt-4 inner-carousel" v-if="randomProperties.length > 0">
                                    <div class="inner-slider" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                                        <div class="property-list" v-for="(item, index) of randomProperties.slice(0, 3)" :key="index">
                                            <div class="sliderImage">
                                                <div class="image-topBtn">
                                                    <button class="btn relet">Relet</button>
                                                    <button class="btn seeall">See all</button>
                                                </div>
                                            </div>
                                            <div style="min-width: 350px;">
                                                <img v-if="item.images.length < 0" style="border-radius: 8px; border: 1px solid #D5D7DA; height: 213px; object-fit: cover;" class="w-100" :src="item.images[0]" alt="img">
                                                <img v-else style="border-radius: 8px; border: 1px solid #D5D7DA;" class="w-100" src="../assets/images/prop1.svg" alt="img">
                                                
                                            </div>
                                            <div>
                                                <h5 style="font-weight: 500 !important; margin-top: 10px; color: #2B3352 !important; " class="ellipsis">{{ item.title }}</h5>
                                                <h5 style="font-weight: 700 !important; margin-top: 10px; color: #0033EA !important; ">₦{{ Number(item.amount).toLocaleString() }}</h5>
                                                
                                                <!-- <div class="d-flex justify-content-between align-items-center">
                                                    
                                                    <div>
                                                        <button class="btn view-detail-btn" @click="moveToPropertyDetailsOppotunity(item.id)">View Details</button>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <!-- <div @click=navigateToMoreOpp(2)>
                                                <h6>{{ item.title }}</h6>
                                                <p>{{ item.description }}</p>
                                                <h5><span>{{ Number(item.amount).toLocaleString() }}</span>/Annually</h5>
                                            </div> -->
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="slide-button">
                                        <button class="btn" :class="[currentIndex == 0 ? 'active-slide' : '']"></button>
                                        <button class="btn" :class="[currentIndex == 1 ? 'active-slide' : '']"></button>
                                        <button class="btn" :class="[currentIndex == 2 ? 'active-slide' : '']"></button>
                                    </div>
                                </div>
                            </div>
                            

                            <div class="right-cards">
                                <h4>Todo list</h4>
                                <div class="d-flex justify-content-between right-list">
                                    <div class="list-options">
                                        <h5>Occupation</h5>
                                        <h6>Provide/update your current occupation for our records.</h6>
                                    </div>
                                    <div class="dark-outlined-btn">
                                        <button class="btn" @click="navigatiionRoutes('/dashboard/profile')">Update</button>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between right-list">
                                    <div class="list-options">
                                        <h5>Means of Identification</h5>
                                        <h6>Provide/update your Means of ID for verification purposes.</h6>
                                    </div>
                                    <div class="dark-outlined-btn">
                                        <button class="btn" @click="navigatiionRoutes('/dashboard/profile')">Update</button>
                                    </div>
                                </div>
                            </div>

                            <div class="right-cards">
                                <h4>Upcoming task</h4>
                                <div v-if="newDasboard.data.upcoming_tasks.length > 0">
                                    <div class="d-flex justify-content-between right-list" v-for="(item, index) in newDasboard.data.upcoming_tasks"
                                            :key="index">
                                        <div class="list-options">
                                            <h5>{{ item.type }}</h5>
                                            <h6>{{item.description}}</h6>
                                        </div>
                                        <!-- <div class="dark-outlined-btn">
                                            <button class="btn">Update</button>
                                        </div> -->
                                    </div>
                                </div>

                                <div v-else class="empty-state mt-5 mb-5">
                                    <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                    <h5>No available data</h5>
                                </div>

                                <!-- <div v-if="newDasboard.data.upcoming_tasks">

                                </div> -->

                                <!-- <div class="d-flex justify-content-between right-list">
                                    <div class="list-options">
                                        <h5>Inspection request</h5>
                                        <h6>Renant at Lagos property requested for inspection.</h6>
                                    </div>
                                    <div class="dark-outlined-btn">
                                        <button class="btn">Update</button>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between right-list">
                                    <div class="list-options">
                                        <h5>Occupation</h5>
                                        <h6>Provide/update your current occupation for our records.</h6>
                                    </div>
                                    <div class="dark-outlined-btn">
                                        <button class="btn">Update</button>
                                    </div>
                                </div> -->
                            </div>

                            <div class="right-cards" v-if="newDasboard.data.user_activitie">
                                <h4>Recent Activities</h4>
                                <div class="right-list" v-for="(item, index) in newDasboard.data.user_activities.slice(0, 3) || []"
                                        :key="index">
                                    <div class="list-options">
                                        <h5>{{item.category}}</h5>
                                        <h6>{{item.description}}</h6>
                                    </div>
                                    <div class="activity-time">
                                        <span><img src="../assets/icons/bx-time.svg" alt="date"> {{item.date | moment3}}</span>   <span><img src="../assets/icons/bx-calendar.svg" alt="date"> {{ item.date | moment2 }}</span>
                                    </div>
                                </div>

                                <!-- <div class="right-list">
                                    <div class="list-options">
                                        <h5>Property Management</h5>
                                        <h6>32 road, Abuja town property was added to your properties</h6>
                                    </div>
                                    <div class="activity-time">
                                        <span><img src="../assets/icons/bx-time.svg" alt="date"> 12:4pm</span>   <span><img src="../assets/icons/bx-calendar.svg" alt="date"> 12th Jan, 2025</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>


                        <!-- Modal to fund project from safe begins -->
                        <div
                        class="modal fade"
                        id="fundproject"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                        >
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content fundmodalContent">
                                <div
                                    class="closeFundProject"
                                    style="border-radius: 20px 20px 0 0;"
                                >
                                    <h6>Transfer funds to project</h6>
                                    <small data-dismiss="modal" aria-label="Close">x</small>
                                </div>
                                <div class="modal-body">
                                    <p class="transferSafeBalance">
                                    Safe Balance:
                                    <span>
                                        &#8358;{{
                                        Number(safeDetails.balance).toLocaleString()
                                        }}</span
                                    >
                                    </p>
                                    <form>
                                    <div class="form-group">
                                        <select
                                        class="form-control"
                                        id="projects"
                                        v-model="projectId"
                                        >
                                        <option slected disabled value="">Select project</option>
                                        <option
                                            v-for="(item, index) in projects"
                                            :key="index"
                                            :value="item.id"
                                            >{{ item.title }}</option
                                        >
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <input
                                        onfocus="(this.type='text')"
                                        type="number"
                                        class="form-control"
                                        id="amountfund"
                                        placeholder="Enter amount"
                                        v-model="transferAmount"
                                        />
                                    </div>
                                    <div class="form-group transfer-btn">
                                        <button class="btn btn-block" @click.prevent="fundProject">
                                        Transfer
                                        <i
                                            class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                            v-if="fundLoader"
                                        ></i>
                                        </button>
                                    </div>
                                    </form>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal to fund project from safe ends -->


                        <!-- Modal to fund blue safe amount begins -->
                        <div
                        class="modal fade"
                        id="fundbluesafe"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                        >
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content fundmodalContent">
                            <div
                                class="closeFundProject"
                                style="border-radius: 20px 20px 0 0;"
                            >
                                <h6>FUND BLUE SAFE</h6>
                                <small
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="
                                    closedPaystack;
                                    fundLoaderBlue = false;
                                "
                                >x</small
                                >
                            </div>
                            <div class="modal-body">
                                <p class="transferSafeBalance">
                                Safe Balance:
                                <span>
                                    &#8358;{{
                                    Number(safeDetails.balance).toLocaleString()
                                    }}</span
                                >
                                </p>
                                <form>
                                <div class="form-group">
                                    <!-- <label for="exampleInputEmail1">Email address</label> -->
                                    <input
                                    onfocus="(this.type='text')"
                                    type="number"
                                    class="form-control"
                                    id="amountfund"
                                    placeholder="Enter amount"
                                    v-model="blueSafeFundAmount"
                                    />
                                </div>

                                <div class="form-group transfer-btn">
                                    <button
                                    class="btn btn-block"
                                    @click.prevent="paymentModalFund2"
                                    >
                                    FUND
                                    <i
                                        class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                        v-if="fundLoaderBlue"
                                    ></i>
                                    </button>
                                </div>
                                </form>
                            </div>
                            </div>
                        </div>
                        </div>
                        <!-- Modal to fund blue safe amount ends -->


                        <!-- Modal to upgrade safe starts -->
                        <div class="modal" tabindex="-1" id="upgradesafe">
                            <div class="modal-dialog modal-dialog-scrollable">
                                <div class="modal-content">
                                <div class="modal-header" style="border-bottom: 1px solid #dee2e6;">
                                    <div v-if="takeAction == 'selectbank'">
                                        <h5 class="modal-title modal-top">Upgrade/add account</h5>
                                        <h6>Fill the form quickly to activate your safe </h6>
                                    </div>
                                    <div v-if="takeAction == 'bvndetails'">
                                        <h5 class="modal-title modal-top">BVN Details</h5>
                                        <h6>Kindly confirm if this is your correct BVN details </h6>
                                    </div>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="validBvn = false; bankActive = ''; bvn = ''">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row" v-if="!validBvn">
                                        <div class="col-md-6">
                                            <label class="upgrade-label" for="bvn">Select Bank</label>
                                            <div class="bank-wrap">
                                                <div class="bank-select-gtb" @click="bankActive = 'gtb'" :class="[bankActive == 'gtb' ? 'activeBank' : '']" v-if="safeDetails.safedata.squadaccountno == null">
                                                    <small v-if="bankActive == 'gtb'"><i class="selected-check fa fa-check"></i></small>
                                                    <img src="../assets/icons/banks-logo.svg" alt="bank_logo">
                                                    <span>GT Bank</span>
                                                </div>
                                                <div class="bank-select-fbn" @click="bankActive = 'fbn'" :class="[bankActive == 'fbn' ? 'activeBank' : '']" v-if="safeDetails.safedata.firstBankaccountNumber == null">
                                                    <small v-if="bankActive == 'fbn'"><i class="selected-check fa fa-check"></i></small>
                                                    <img src="../assets/icons/fbn-logo.svg" alt="bank_logo">
                                                    <span>First Bank</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                             <div class="form-group">
                                                <label class="upgrade-label" for="bvn">Enter BVN</label>
                                               <input type="text" class="form-control" id="bvn" min="1" max="11" maxlength="11" placeholder="Please provide BVN to continue" v-model="bvn">
                                             </div>
                                        </div>
                                    </div>
                                    <div class="" v-if="validBvn">

                                        <div class="row">
                                            <div class="form-group col-6">
                                                <label for="fnamebvn">First Name</label>
                                                <input disabled v-model="fnamebvn" type="text" class="form-control" id="fnamebvn" placeholder="First name">
                                            </div>

                                            <div class="form-group col-6">
                                                <label for="lnamebvn">Last Name</label>
                                                <input disabled v-model="lnamebvn" type="text" class="form-control" id="lnamebvn" placeholder="Last name">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-6">
                                                <label for="mnamebvn">Middle Name</label>
                                                <input disabled v-model="mnamebvn" type="text" class="form-control" id="mnamebvn" placeholder="Middle name">
                                            </div>
                                            <div class="form-group col-6">
                                                <label for="emailbvn">Email</label>
                                                <input disabled v-model="emailbvn" type="text" class="form-control" id="emailbvn" placeholder="Email">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="form-group col-6">
                                                <label for="phonebvn">Phone number</label>
                                                <input disabled v-model="phonebvn" type="text" class="form-control" id="phonebvn" placeholder="Phone number">
                                            </div>
                                            <div class="form-group col-6">
                                                <label for="dobbvn">Date of birth</label>
                                                <input disabled v-model="dobbvn" type="text" class="form-control" id="dobbvn" placeholder="Date of birth">
                                            </div>
                                        </div>

                                        <!-- <div class="form-group" v-if="addressbvn != '' || addressbvn != null">
                                            <label for="addressbvn">Address</label>
                                            <input v-model="addressbvn" type="text" class="form-control" id="addressbvn" placeholder="Address">
                                        </div>   -->
                                        <!-- <div class="form-group col-6">
                                            <label for="destination">Destination</label>
                                            <select class="form-control" id="destination" v-model="accountId">
                                                <option selected disabled value="">Select bank</option>
                                                <option :value="item.id" v-for="(item, index) in userAccounts" :key="index">{{item.bank_name}} - {{item.account_number}}</option>
                                            </select>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn white-outline-btn" data-dismiss="modal" @click="validBvn = false; bankActive = ''; bvn = ''">Close</button>
                                    <button v-if="!validBvn" :disabled="validateLoader" type="button" class="btn sheltaPrimaryBtn"  @click="checkBvnStatusUniversal()">Validate
                                        <span v-if="validateLoader"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                    </button>
                                    <button v-if="validBvn" :disabled="activateLoader || loadingCreatAccount" type="button" class="btn sheltaPrimaryBtn"  @click="upgrateAccountGTBFBN()">Upgrade
                                        <span v-if="activateLoader || loadingCreatAccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                    </button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal to upgrade safe starts -->

                        <!-- <component class="more-content" :is="PaymentModal"></component> -->
                            <PaymentModal
                            @paystackReference="dataFromPaymentModal($event)"
                            :dataForPayment="modalData"
                            v-model="paymentM"
                            ></PaymentModal>
                        <!-- <component class="" :header="headerCaption" :is="PaymentModal"></component> -->
                    </div>

                    
                </div>
                <SafeWithdrawal></SafeWithdrawal>
            </div>
        </div>
    </div>
</template>


<script>
// import ApexCharts from "vue3-apexcharts";
// import VueApexCharts from "vue-apexcharts";
// import SmallNav from "./SmallNav";
import PaymentModal from "./PaymentModal.vue";
import moment from "moment";
import PageLoader from "./PageLoader.vue";
import { fetchUserAccount, fetchNewLandlordDashboard } from './helpers';
import SafeWithdrawal from "./SafeWithdrawal"
import { Service } from "../store/service";
import Vue from "vue";
const Api = new Service();
import $ from "jquery";
import CryptoJS from "crypto-js";
import CoachRequests from "./CoachRequests";
// import  PromoGif from "./PromoGif";
import gif from "../components/SuperKid/gif.vue";


export default {
    name: "LandlordDashboard",
    components: {
        SafeWithdrawal,
        PageLoader,
        PaymentModal,
        CoachRequests,
        // PromoGif,
        gif
        // SmallNav
        // apexchart: ApexCharts
        // apexchart: VueApexCharts,
    },
    data() {
        return {
            pageLoader: false,
            registedForSafe: false,
            amountVisibility: false,
            rewardVisibility: false,
            fundLoaderBlue: false,
            validateLoader: false,
            activateLoader: false,
            loadingCreatAccount: false,
            paymentM: false,
            fundLoader: false,
            withdrawing: false,
            activateAddress: false,
            validBvn: false,
            bvn: "",
            takeAction: 'selectbank',
            bankActive: "",
            modalData: {},
            safeDetails: {
                balance: 0,
                safedata: '000000000000',
            },
            whichSafe: "",
            series: [
                {
                    name: 'Paid',
                    data: [50, 65, 70, 80,] // week 1–4 values
                },
                {
                    name: 'Unpaid',
                    data: [30, 20, 25, 40]
                }
            ],
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 8,
                        borderRadiusApplication: 'end',
                        horizontal: false,
                        columnWidth: '35%',  // keeps bars close together
                        endingShape: 'rounded'
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ['#0033EA', '#3399FF'], // Paid = green, Unpaid = red
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4']
                },
                // yaxis: {
                //     title: {
                //         text: 'Payments (₦)'
                //     }
                // },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 4,  // 4 intervals = 5 ticks: 0, 25, 50, 75, 100
                    labels: {
                        formatter: function (val) {
                            if (val === 0) return '0-25%';
                            if (val === 25) return '25-50%';
                            if (val === 50) return '50-75%';
                            if (val === 75) return '75-100%';
                            if (val === 100) return ''; // you can leave top value empty or as '100%'
                            return '';
                        }
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: val => `₦${val}`
                    }
                },
                legend: {
                    position: 'top'
                }
            },
            propItem: [
                {
                title: "3 bedroom fully detached duplex1",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                },
                {
                title: "2 bedroom fully detached duplex2",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                },
                {
                title: "3 bedroom fully detached duplex3",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                }
            ],
            currentAccountDetails: {},
            randomProperties: [],
            currentIndex: 0,
            interval: null,
            accountss: [],
            projects: [],
            projectId: "",
            transferAmount: "",
            user: "",
            newDasboard: {
                data: {
                    upcoming_tasks: [],
                    number_of_tenants: 0,
                    pending_rent: 0      ,
                    maintenance_requests: 0,
                    projects_count: 0,  
                    today_rewards: 0,
                    shelta_points: 0,
                    percentage_increase: 0,
                    safe_last_funded: {
                        created_at: null
                    }       
                }
            },
            upcomingTask: [],
            recentActivities: [],
            blueSafeFundAmount: "",
            pvtData: "",
            diableBvnInput: false,
            bvndata: {},
            secret: "123#$%",
            encData: "",
            decryptBvn: "",
            cookiesData: "",
            fnamebvn: "",
            lnamebvn: "",
            mnamebvn: "",
            emailbvn: "",
            phonebvn: "",
            addressbvn: "",
            genderbvn: "",
            dobbvn: "",
            url: "",
            fbnReservationId: "",
            safeState: "",
            typeOfSafe: "",
            switchAccountInfo: {},
            nearest_tenant_rent: "",
            guaranteeRent: null,
            now: new Date().getTime(),
            timer: null,
            // Target dynamic dates in ISO format or future timestamps
            // rentals: [
            //     {
            //     id: 1,
            //     targetDate: new Date(Date.now() + 8 * 24 * 60 * 60 * 1000).toISOString(), // 8 days away
            //     maxDurationMs: 30 * 24 * 60 * 60 * 1000, // 30 days total baseline for full circle progress
            //     title: 'Guaranteed Rent Incoming',
            //     address: 'No.4 Lord Lugard Street, Maitama, Abuja',
            //     percentage: 100
            //     },
            //     {
            //     id: 2,
            //     targetDate: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(), // 5 hours away (Triggers hours layout)
            //     maxDurationMs: 24 * 60 * 60 * 1000, // 24 hours baseline
            //     title: 'Guaranteed Rent Incoming',
            //     address: 'Plot 1024 Adetokunbo Ademola Crescent, Wuse II',
            //     percentage: 100
            //     },
            //     {
            //     id: 3,
            //     targetDate: new Date(Date.now() + 45 * 60 * 1000).toISOString(), // 45 minutes away (Triggers minutes layout)
            //     maxDurationMs: 60 * 60 * 1000, // 1 hour baseline
            //     title: 'Guaranteed Rent Incoming',
            //     address: 'Avenue 2, Gwarinpa Estate, Abuja',
            //     percentage: 100
            //     }
            // ],
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        this.stopAutoSlide();
    },
    watch: {
        transferAmount: function(newValue) {
        const result = newValue
            .replace(/[^.\d]/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        Vue.nextTick(() => (this.transferAmount = result));
        },
        blueSafeFundAmount: function(newValue) {
        const result = newValue
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        Vue.nextTick(() => (this.blueSafeFundAmount = result));
        },
        bankActive: function(newValue, oldValue) {
            // console.log("cavtive bank select", newValue, oldValue)
        }
    },
    async created() {
        await this.fetchUserAccountFunc();
        await this.fetchNewDashboardFunc();
        await this.propeetiesForGuaranteeRent();
        // await this.createUser();
    },
    computed: {
      computedRentals() {
        if (!this.guaranteeRent || typeof this.guaranteeRent.count_down_date !== 'string') {
            return null;
        }

        const radius = 31;
        const circumference = 2 * Math.PI * radius;
  
        // Extract values from your specific server payload
        const serverPayload = this.guaranteeRent;
        const tenantRent = serverPayload.nearest_tenant_rent || {};

        // Safely parse your "DD-MM-YYYY" format string ("18-10-2026")
        const dateParts = serverPayload.count_down_date.split('-');
        
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // JS Months run 0-11
        const year = parseInt(dateParts[2], 10);
  
        // const currentTime = this.now || new Date().getTime();
        const targetTime = new Date(year, month, day).getTime();
        const difference = targetTime - this.now;

        let displayValue = 0;
        let displayUnit = 'mins';
        let isUrgent = false;

        // 1. Manage countdown string breakdown states
        if (difference > 0) {
            const totalMinutes = Math.ceil(difference / (1000 * 60));
            const totalHours = Math.ceil(difference / (1000 * 60 * 60));
            const totalDays = Math.ceil(difference / (1000 * 60 * 60 * 24));

            if (totalDays >= 1) {
            displayValue = totalDays;
            displayUnit = totalDays === 1 ? 'day' : 'days';
            } else if (totalHours >= 1) {
            displayValue = totalHours;
            displayUnit = totalHours === 1 ? 'hour' : 'hours';
            isUrgent = true;
            } else {
            displayValue = totalMinutes;
            displayUnit = totalMinutes === 1 ? 'min' : 'mins';
            isUrgent = true;
            }
        }

        // 2. Map progress tracking values based on your exact `days_remaining` property
        // Change 100 to your maximum baseline window (e.g., 90-day or 365-day cycle)
        const maxBaselineDays = 100; 
        const progress = Math.max(0, Math.min(serverPayload.days_remaining / maxBaselineDays, 1));
        const strokeOffset = circumference * (1 - progress);
        const percentage = Math.round(progress * 100);

        // Return a single configured object containing the dynamic properties
        return {
            title: 'Guaranteed Rent',
            // Tie layout properties dynamically to your server keys
            address: tenantRent.address || 'No property address found', 
            occupiedProperties: serverPayload.occupied_properties,
            displayValue,
            displayUnit,
            strokeOffset,
            percentage,
            isUrgent
        };


        // const radius = 31;
        // const circumference = 2 * Math.PI * radius;

        // return this.rentals.map(item => {
        //   const targetTime = new Date(item.targetDate).getTime();
        //   const difference = targetTime - this.now;

        //   let displayValue = 0;
        //   let displayUnit = 'mins';
        //   let isUrgent = false;

        //   if (difference > 0) {
        //     const totalMinutes = Math.floor(difference / (1000 * 60));
        //     const totalHours = Math.floor(difference / (1000 * 60 * 60));
        //     const totalDays = Math.floor(difference / (1000 * 60 * 60 * 24));

        //     if (totalDays >= 1) {
        //       displayValue = totalDays;
        //       displayUnit = totalDays === 1 ? 'day' : 'days';
        //     } else if (totalHours >= 1) {
        //       displayValue = totalHours;
        //       displayUnit = totalHours === 1 ? 'hour' : 'hours';
        //       isUrgent = true; // Visual indicator switch
        //     } else {
        //       displayValue = totalMinutes;
        //       displayUnit = totalMinutes === 1 ? 'min' : 'mins';
        //       isUrgent = true;
        //     }
        //   }

        //   // Keep radial track tracking total timeline percentage accurately
        //   const progress = Math.max(0, Math.min(difference / item.maxDurationMs, 1));
        //   const strokeOffset = circumference * (1 - progress);

        //   return {
        //     ...item,
        //     displayValue,
        //     displayUnit,
        //     strokeOffset,
        //     isUrgent
        //   };
        // });
      }
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem("shelta-user"));
        // this.typeOfSafe = localStorage.getItem("safeType");
        this.safeState = localStorage.getItem("upgradeSafe");
        this.fetchSafeData();
        this.opportunityByCategory();
        this.startAutoSlide();
        this.getProjects();

        // countdown
        this.timer = setInterval(() => {
            this.now = new Date().getTime();
        }, 30000); 
        // countdown
        // this.checkBvnStatusUniversal();

        // if (this.safeState != "upgradeToGold") {
        //     this.url = "registerforsafe2";
        //     } else {
        //     this.url = "upgradesafetogold2";
        // }

        // console.log("User account function", this.fetchUserAccount())
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        padZero(num) {
            return num < 10 ? `0${num}` : num;
        },
        dismissCard(id) {
            this.rentals = this.rentals.filter(item => item.id !== id);
        },
        topNavigation(data) {
            if (data === 1) {
                this.$gtag.event("guarantee-rent-t=request-click", {
                event_category: "dashboard documentaion clicks",
                event_label: "Landlord guarantee rent request Button Clicked",
                value: 1
                });
                this.$router
                .push({
                    path: `/dashboard/guarentee-rent-home`
                })
                .catch(() => {});
            } else if (data === 2) {
                this.$gtag.event("add-property-initial-click", {
                event_category: "dashboard documentaion clicks",
                event_label: "Add a New Property Button Clicked",
                value: 1
                });
                this.$router
                .push({
                    path: `/addproperty`
                })
                .catch(() => {});
            }
        },
        widthdrawFromSafeTrigger() {
            this.$root.$refs.openConfirm.openConfirmModal();
        },
        navigatiionRoutes(route) {
            this.$router
                .push({
                path: `${route}`
                })
                .catch(() => {
                // console.log("none")
            });
        },
        async fetchUserAccountFunc() {
            try {
                this.accountss = await fetchUserAccount();
                // console.log("User accountsss", this.accountss);
                // if (this.accountss) {
                //     console.log("User accoint", this.accountss);
                // }
                
            } catch (error) {
                console.error(error)
            }
        },
        async fetchNewDashboardFunc() {
            try {
                this.newDasboard = await fetchNewLandlordDashboard();
                // console.log("Landlord Dashboard1", this.newDasboard);
                // if (this.newDasboard.data.success) {
                //     console.log("Landlord Upcoming task", this.newDasboard);
                // }
                
            } catch (error) {
                console.error(error)
            }
        },
        async propeetiesForGuaranteeRent() {
            try {
                await Api.postRequest(`fetch-land-lord-guaranteed-rent`, {}).then(res => {
                    console.log("Guarantee rent", res);
                    if (res.data.success) {
                        this.guaranteeRent = res.data;
                        this.nearest_tenant_rent = res.data.nearest_tenant_rent;
                    }
                }).catch(err => {
                    console.log("Err:", err)
                })
            } finally {
                // console.log("closed")
            }
        },
        async opportunityByCategory() {
            this.loading = true;
            await Api.getRequest(`get-opportunity-by-category-id/${'2'}`)
            .then(data => {
            // await opportunities.opportunityDeskByCategoryId('2').then(data => {
                // console.log("Opportunitiescategories:", data);
                this.loading = false;
                if (data.data.success) {
                    this.randomProperties = data.data.data;
                } else {
                    this.$toast.error(data.error);
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.propItem.length;
        },
        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.propItem.length) % this.propItem.length;
        },
        startAutoSlide() {
            this.interval = setInterval(this.nextSlide, 4000);
        },
        stopAutoSlide() {
            clearInterval(this.interval);
        },
        copyAccountNumber(value) {
            navigator.clipboard.writeText(value)
            .then(() => {
                this.$store.commit("setApiSuccess", `Copied ${value}`);
            })
            .catch(err => {
                console.error('Failed to copy: ', err)
            })
        },
        async fetchSafeData() {
            this.pageLoader = true;
            // console.log("are you safe", this.registedForSafe);
            try {
                await Api.getRequest(`fetchsafedata`)
                .then(res => {
                    this.pageLoader = false;
                    if (res.data.success) {
                    // console.log("Safe data", res);
                    this.safeDetails = res.data;
                    this.currentAccountDetails = JSON.parse(res.data.safedata.current_account);
                    if (res.data.safedata != null) {
                        this.registedForSafe = true;
                        // this.transactionList();
                        // this.serviceData();
                        // this.again();
                        // this.transactions = this.$store.value.data.transactions;
                        this.transactions = res.data.transactions;
                        // let x = JSON.parse(res.data.safedata.current_account);
                        // if (res.data.safedata.current_account != null) {
                        //     let x = JSON.parse(res.data.safedata.current_account);
                        //     x.account_number = res.data.safedata.squadaccountno;
                        //     this.switchAccountInfo = x;
                        // }
                        // x.account_number = res.data.safedata.squadaccountno;
                        // this.switchAccountInfo = x;
                        if (res.data.safedata.bvn != null) {
                        this.registedForSafe = true;
                        this.whichSafe = "yellowSafe";
                        } else {
                        this.whichSafe = "blueSafe";
                        // this.registedForSafe = false;
                        this.registedForSafe = true;
                        }
                    } else {
                        this.registedForSafe = false;
                    }

                    // if (res.data.safedata.bvn == null) {
                    //   this.whichSafe = "blueSafe";
                    //   // this.registedForSafe = false;
                    //   this.registedForSafe = true;
                    // }
                    }
                    if (res.data.error) {
                    this.$store.commit("setApiFailed", "Can not read account");
                    }
                })
                .catch(err => {
                    this.pageLoader = false;
                    console.log(err);
                    if (err == "Error: Network Error") {
                    this.registedForSafe = "";
                    }
                    // this.loader = false;
                    // this.uploading = true;
                });
            } finally {
                // console.log("Closed connection");
            }
        }, 
        getProjects() {
            this.pageLoader = true;
            Api.getRequest(`getusersafeprojectsbyuserid/${this.user.id}`)
                .then(res => {
                // console.log("Projects", res);
                this.pageLoader = false;
                if (res.data.success) {
                    this.projects = res.data.projects;
                }
                if (res.data.error) {
                    this.$store.commit("setApiFailed", res.data.error);
                }
                })
                .catch(err => {
                    this.pageLoader = false;
                    console.log("err", err);
            });
        },
        async fundProject() {
            this.fundLoader = true;
            if (this.projectId === "" || this.transferAmount === "") {
                this.fundLoader = false;
                return this.$store.commit("setApiFailed", "All fields are required");
            }
            const formattedAmount = this.transferAmount.split(",").join("");
            if (formattedAmount > this.safeDetails.balance) {
                this.fundLoader = false;
                return this.$store.commit(
                "setApiFailed",
                "Amount entered exceeds safe balance"
                );
            } else {
                try {
                await Api.postRequest(`creditprojectfromsafe`, {
                    amount: parseFloat(formattedAmount),
                    projectid: this.projectId
                })
                    .then(res => {
                    this.fundLoader = false;
                    // console.log("Funds transfer succefully", res);
                    if (res.data.success) {
                        this.$store.commit("setApiSuccess", "Success");
                        this.fetchSafeData();
                        $("#fundproject")
                        .removeClass("fade")
                        .modal("hide");
                    }
                    if (res.data.error) {
                        this.$store.commit("setApiFailed", res.data.error);
                    }
                    })
                    .catch(err => {
                    console.log("err", err);
                    this.fundLoader = false;
                    });
                } finally {
                // console.log("close");
                }
            }
        },
        async fundBlueSafe() {
            // this.fundLoaderBlue = true;
            // console.log("Reffffff:", this.reference);
            if (this.reference === "") {
                return this.$store.commit("setApiFailed", "No payment reference");
            }
            try {
                await Api.postRequest(`creditbluesafefrompaystack`, {
                reference: this.reference
                })
                .then(res => {
                    // console.log("Fund blu safe response", res);
                    this.fundLoaderBlue = false;
                    if (res.data.success) {
                    return this.$store.commit(
                        "setApiSuccess",
                        "SAFE has been funded"
                    );
                    }
                    if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                    }
                })
                .catch(err => {
                    console.log("err", err);
                    this.fundLoaderBlue = false;
                });
            } finally {
                // console.log("closed");
            }
        },
        paymentModalFund2: function() {
            // this.fundLoaderBlue
            if (this.blueSafeFundAmount === "") {
                return this.$store.commit("setApiFailed", "Enter amount");
            }
            const formattedAmount = this.blueSafeFundAmount.split(",").join("");
            const b = Number(formattedAmount) + Number(this.safeDetails.balance);
            if (b > 500000) {
                return this.$store.commit(
                "setApiFailed",
                "Estimated safe balance can't be more 500,000"
                );
            }
            // this.fundLoaderBlue = true;
            // console.log("Open payment");
            // this.paymentM = true;
            this.modalData.amount = 0;
            this.modalData.payableAmount = Number(formattedAmount);
            this.modalData.headerCaption = "Fund Your Blue SAFE";
            this.modalData.subtitle = "Fund Amount";
            this.modalData.paymentType = "fundbluesafe";
            this.modalData.headerBackground = "#0033ea";
            this.modalData.headerBackground = "#0033ea";
            // this.modalData.url = "";
            this.$root.$refs.A.openPaymentOptionsModal();
            $("#fundbluesafe")
            .removeClass("fade")
            .modal("hide");
        },
        closedPaystack() {
            this.fundLoaderBlue = false;
            this.fundLoader = false;
            this.blueSafeFundAmount = "";
        },
        encryptData() {
            if (this.bvn.length) {
                // hash the name with any algorithm
                const data = CryptoJS.AES.encrypt(this.bvn, this.secret).toString();
                this.encData = data;
                this.saveCookiesForBvn();
                // display the encrypted data
                this.getEncryptedData();
            }
        },

        async decryptData() {
            this.cookiesData = this.$cookies.get("_sheltaSafeData");
            const secretData = this.cookiesData.bvn;
            // decrypt the data and convert to string
            this.decryptBvn = await CryptoJS.AES.decrypt(
                secretData,
                this.secret
            ).toString(CryptoJS.enc.Utf8);
        },
        getEncryptedData() {
            // get the data from localStorage or send placeholder text
            this.decryptData();
            // this.encData = localStorage.getItem("secretData") || "No value present";
        },
        saveCookiesForBvn() {
            // const now = new Date();
            // const time = now.getTime();
            // const expireTime = time + 1000 * 36000;
            // now.setTime(expireTime);
            // document.cookie = "cookie=ok;expires='+now.toUTCString()+';path=/";
            const bvndata = {
                fname: this.bvndata.first_name,
                lname: this.bvndata.last_name,
                middleName: this.bvndata.middle_name,
                address: this.bvndata.residential_address,
                phone: this.bvndata.phone_number1,
                dob: this.bvndata.date_of_birth,
                email: this.user.email,
                gender: this.bvndata.gender,
                bvn: this.encData
            };

            if (this.bvndata.middle_name == "" || this.bvndata.middle_nam == null) {
                bvndata.middleName = "-";
            }
            const date = new Date();
            date.setDate(date.getDate() + 1);
            this.$cookies.set("_sheltaSafeData", bvndata, date);
            // console.log("new date", date);
        },
        async checkBvnStatusUniversal() {
            this.validateLoader = true;
            if (this.safeDetails.raw_bvn == null) {
                try {
                await Api.postRequest(`check-if-bvn-exist`, { bvn: this.bvn }).then(res => {
                    // this.validateLoader = false;
                    if (res.data === true) {
                        this.validateLoader = false;
                        return this.$store.commit("setApiWarning", "BVN Already Exist");
                    }
                    if (res.data === false) {
                        this.bvnCheck();
                    }
                }).catch(err => {
                    console.log("err", err);

                    });
                } finally {
                    // console.log("closed");
                }
            }
            else {
                this.bvnCheck();
            }
            
        },
        async bvnCheck() {
            // let x = "{\"error\":\"BVN not found\"}";
            // let ret = x.replace('{\"error\":\"\"}"','');
            // let ret2 = x.replace('\"}','');
            // console.log("strip data", ret);

            this.validateLoader = true;
            if (this.bankActive === '') {
                this.$store.commit("setApiWarning", "Select bank");
                this.validateLoader = false;
                return;
            }
            if (this.bvn === "") {
                this.$store.commit("setApiWarning", "Enter BVN");
                this.validateLoader = false;
                return;
            }
            this.decryptData();
            if (this.decryptBvn === this.bvn) {
                // console.log("bvn cookies", this.cookiesData);
                this.validateLoader = false;
                this.validBvn = true;
                // this.$store.commit("setApiSuccess", "Success");
                this.fnamebvn = this.cookiesData.fname;
                this.lnamebvn = this.cookiesData.lname;
                this.mnamebvn = this.cookiesData.middleName;
                this.addressbvn = this.cookiesData.address;
                this.phonebvn = this.cookiesData.phone;
                this.genderbvn = this.cookiesData.gender;
                this.dobbvn = this.cookiesData.dob;
                this.emailbvn = this.cookiesData.email;
                // this.gender = this.cookiesData.gender;
                if (this.addressbvn == "" || this.addressbvn == null) {
                this.activateAddress = true;
                } else {
                this.activateAddress = false;
                }
            } else {
                try {
                await Api.postRequest(`bvncheckwithdojah`, { bvn: this.bvn })
                    .then(res => {
                    // console.log("New bvn check on init", res);
                    this.validateLoader = false;
                    this.takeAction = 'bvndetails'
                    if (res.data.success === "success") {
                        // this.$store.commit("setApiSuccess", "Success");
                        this.validBvn = true;
                        this.bvndata = res.data.data;
                        // console.log("bvn data", this.bvndata);
                        this.fnamebvn = this.bvndata.first_name;
                        this.lnamebvn = this.bvndata.last_name;
                        this.mnamebvn = this.bvndata.middle_name;
                        this.genderbvn = this.bvndata.gender;
                        this.addressbvn = this.bvndata.residential_address;
                        this.phonebvn = this.bvndata.phone_number1;
                        this.dobbvn = this.bvndata.date_of_birth;
                        this.emailbvn = this.user.email;
                        // this.gender = this.bvndata.gender;
                        if (
                        this.bvndata.middle_name == "" ||
                        this.bvndata.middle_name == null
                        ) {
                        this.addressbvn = "-";
                        } else {
                        this.mnamebvn = this.bvndata.middle_name;
                        }
                        if (
                        this.bvndata.residential_address == "" ||
                        this.bvndata.residential_address == null
                        ) {
                        this.activateAddress = true;
                        } else {
                        this.activateAddress = false;
                        }
                        this.encryptData();
                        // if (this.bvndata.email == "" || this.bvndata.email == null) {
                        //   this.activateInput = true;
                        // } else {
                        //   this.activateInput = false;
                        // }
                    }
                    if (res.data.error) {
                        this.validBvn = false;
                        if (
                        res.data.error_data ==
                        '{"error":"Your balance is low, pls visit the dashboard to top up"}'
                        ) {
                        this.$store.commit(
                            "setApiFailed",
                            "Can't check BVN now contact Shellta"
                        );
                        }
                        if (res.data.error_data == '{"error":"BVN not found"}') {
                        this.$store.commit("setApiFailed", "BVN not found");
                        } else {
                        this.$store.commit("setApiFailed", res.data.error);
                        }
                    }
                    })
                    .catch(err => {
                    console.log("err", err);
                    this.validBvn = false;
                    this.diableBvnBtn = false;
                    this.validateLoader = false;
                    });
                } finally {
                // console.log(closed);
                }
            }
        },
        sendMailForSafe() {
            Api.postRequest(`sendsafewelcomemail`, {})
                .then(res => {
                // console.log('');
                })
                .catch(err => {
                console.log("err", err);
            });
        },
        async activateGoldSafe() {
            this.activateLoader = true;
            if (this.emailbvn == "" || this.emailbvn == null) {
                this.activateLoader = false;
                return this.$store.commit("setApiFailed", "Email is required");
            }
            // if (this.addressbvn == "" || this.addressbvn == null || this.addressbvn == '-') {
            //     this.activateLoader = false;
            //     return this.$store.commit("setApiFailed", "Address is required");
            // } 
            else {
                try {
                // await Api.postRequest(`${this.url}`, {
                    await Api.postRequest(`upgradesafetogold`, {
                    first_name: this.fnamebvn,
                    last_name: this.lnamebvn,
                    middle_name: this.mnamebvn,
                    gender: this.genderbvn,
                    mobile_num: this.phonebvn,
                    email: this.emailbvn,
                    dob: this.dobbvn,
                    address: this.addressbvn,
                    bvn: this.bvn
                })
                    .then(res => {
                    // console.log("activate safe response", res);
                    this.activateLoader = false;
                    this.validBvn = false;
                    this.bvn = "";
                    if (res.data.success) {
                        this.$store.commit("setApiSuccess", "success");
                        localStorage.removeItem("safeType");
                        localStorage.removeItem("upgradeSafe");
                        this.$cookies.remove("_sheltaSafeData");
                        $("#upgradesafe")
                        .removeClass("fade")
                        .modal("hide");
                        this.sendMailForSafe();
                        this.bankActive = "";
                    }
                    if (res.data.error) {
                        this.$store.commit("setApiFailed", res.data.error);
                        this.bankActive = "";
                    }
                    })
                    .catch(err => {
                    console.log("err", err);
                    this.activateLoader = false;
                    this.validBvn = false;
                    });
                } finally {
                // console.log(closed);
                }
            }
        },
        async createFBNAccount() {
            if (this.fnamebvnn == '' || this.lnamebvn == '' || this.emailbvn == "" || this.phonebvn == "" || this.bvn == "") {
                return this.$store.commit("setApiFailed", "All fields are required");
            }
            this.loadingCreatAccount = true;
            try {
                await Api.postRequest(`fbn-virtual`, {
                    first_name: this.fnamebvn,
                    last_name: this.lnamebvn,
                    mobile_num: this.phonebvn,
                    email: this.emailbvn,
                    bvn: this.bvn,

                })
                .then(res => {
                    this.loadingCreatAccount = false;
                    // console.log("Create first bank account", res);
                    if (res.data.success) {
                        // this.accountname = res.data.data.accountName;
                        this.$store.commit("setApiSuccess", "Account Created Successful");
                        this.letsvalidate = false;
                        $("#upgradesafe")
                        .removeClass("fade")
                        .modal("hide");
                        this.fbnReservationId = rea.data.reservation_id;
                        this.fetchFBNbankCode();
                        this.bankActive = "";
                        
                    }
                    if (res.data.error){
                        this.$store.commit("setApiFailed", res.data.error);
                        this.bankActive = "";
                    }
    
                    // this.$store.commit("setApiSuccess", "Success");
                })
                .catch(err => {
                    this.loadingCreatAccount = false;
                    // console.log(err);
                    this.$store.commit("setApiFailed", "An error occured");
                });
            } finally {
                // console.log("Closed connection");
            }
        },

        upgrateAccountGTBFBN() {
            if (this.bankActive == 'gtb') {
                return this.activateGoldSafe();
            }
            if (this.bankActive == 'fbn') {
                return this.createFBNAccount();
            }
        },
        async fetchFBNbankCode() {
            await Api.getRequest(`get-fbn-account-details-by-reservation-id/${this.fbnReservationId}`)
            .then(data => {
                // console.log("Reservation done", data)
                if (data.data.success) {
                    // this.fbnReservationId = data.data.;
                    this.fetchSafeData();
                } else {
                    this.$toast.error(data.error);
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        },
    }
    
}
</script>



<style scoped lang="scss">
$asheGrey: #555C74;
$primary: #0033ea;
$white: #ffffff;
$yellow: #ffb100;
$sheltaBlack: #2B3352;

$secondary: #ffffff;
$tatiary: #a2b0e3;
$black: #000000;
$limeGreen: #3ec250;


.headerss {
    display: flex;
    justify-content: space-between;
    text-align: left;
}

.dashboard-holder {
    margin-top: 10px;
}
.card-cover {
    background: #ffffff;
    border-radius: 4px;
    padding: 16px;
}

.top_bar_holder {
  padding: 15px;
  // position: relative;
  background: linear-gradient(180.48deg, #000000 -92.86%, #0033ea 130.64%),
    #ffffff;
  border-radius: 10px 10px 0 0;
  margin: 0 20px;
  // position: fixed;
  width: -webkit-fill-available;
  max-width: 100%;
  top: 54px;
  z-index: 10;
  margin: 1rem;
  // margin-top: 3rem;
}

// .small_nav_holder {
//   margin-top: 5rem;
// }

.top_bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  div:first-child {
    p {
      font-family: Gotham;
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      line-height: 30px;
      padding-right: 20px;
      color: $secondary;
      margin-bottom: 0;
    }
  }
  button:nth-child(2) {
    background: $secondary;
    color: $primary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 30px;
    max-width: 340px;
    width: 100%;
    img {
      padding-right: 20px;
    }
  }
  button:nth-child(3) {
    background: #2fc643;
    color: $secondary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 30px;
    max-width: 324px;
    width: 100%;
    display: flex;
    align-items: center;
    img {
      padding-right: 16px;
      padding-left: 0px;
    }
  }
}

.top_bar_payrent {
  font-family: Gotham;
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 44px;
  padding-right: 20px;
  color: $secondary;
  margin-bottom: 0;
}
.existing_prop_btn {
  button {
    background: $secondary;
    color: $primary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    max-width: 340px;
    width: 100%;
    img {
      padding-right: 20px;
      padding-left: 0px;
    }
  }
}

.add_prop_rentfinancing_btn {
  button {
    background: #2fc643;
    color: $secondary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px !important;
    max-width: 324px;
    width: 100%;
    // display: flex;
    align-items: center;
    img {
      padding-right: 16px;
      padding-left: 0px;
    }
  }
}

.top-card {
    h5, h6 {
        font-family: Lato;
        font-weight: 600;
        color: #4A4A4A;
        // line-height: 100%;
        text-align: left;
    }
    h5 {
        font-size: 18px;
    }
    h6 {
        font-size: 12px;
    }


}

.add-prop-btn {
    button {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        outline: 0;
        box-shadow: none;
        span {
        font-weight: 600;
        font-size: 16px;
       }

    }
}

.dashboard-count {
    .row {
        flex-wrap: nowrap;
        overflow: scroll;
    }
    margin-top: 40px;
    // div {
    //     padding: ;
    // }
    img {
        background: #D1DBFF66;
        padding: 20px;
        border-radius: 50px;
    }
    h6 {
        margin-top: 8px;
        white-space: nowrap;
        span {

            font-family: Lato;
            font-weight: 700;
            font-size: 14px;
            line-height: 150%;
            text-align: center;
            text-transform: capitalize;
            color: #333333;

        }
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        text-transform: capitalize;
        color: #333333;

    }
}

.safe-card {
    padding: 16px 25px;
    background: #ffffff;
    border-radius: 12px;
    min-height: 205px;
}

.safe-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 160%;
        color: #00155F;
        margin-bottom: 0;
    }
}

.af {
    font-family: Lato;
    font-weight: 500;
    font-size: 15px;
    line-height: 160%;
    color: #374151;
    text-align: left;
    margin-top: 10px;
}
.dropdown {
    width: fit-content !important;
}
.dropdown-item { 
    font-family: Lato;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    cursor: pointer;
}
.dropdown-item:hover {
    background: #dadbdd !important;
}

.safe-amount {
    display: flex;
    justify-content: space-between;
    h3, small {
        font-family: Lato;
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;
        color: #374151;
        text-align: left;
        span {
            color: #2BC300;
            font-family: Lato;
            font-weight: 500;
            font-size: 14px;
            line-height: 150%;
            margin-left: 7px;
        }
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        line-height: 150%;
        color: #555C74;
        text-align: left;
    }
}

.account-number {
    display: flex;
    gap: 5px;
    text-align: left;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        // line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
        display: flex;
    }
}
.bank-details {
    display: flex;
    justify-content: space-between;
}
input:disabled {
    background: inherit !important;
}
.white-outline-btn {
    border: 1px solid #D2D2D2;
    background: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    outline: 0;
    box-shadow: none;
}
a {
    text-decoration: none;
}

.primaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}

.right-cards {
    background: #ffffff;
    padding: 8px 24px 24px 24px;
    margin-bottom: 10px;

    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 150%;
        color: #00155F;
        text-align: left;

    }
}

.list-options {
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 125%;
        color: #2B3352;
        text-align: left;
        text-transform: capitalize;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #555C74;
        text-align: left;
    }
}

.right-list {
    background: #FAFAFA;
    padding: 16px 12px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.dark-outlined-btn {
    button {
        border: 1px solid #00155F;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

.activity-time {
    text-align: right;
    span {
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        line-height: 17.21px;
        color: #4B5563;
    }
}

.project-holder {
    margin-top: 30px;
}
.project-list {
    display: flex;
    justify-content: space-between;
    background: #FCFBFB;
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 15px;
    gap: 20px;
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: #2B3352;
        text-align: left;
    }
    h6 {
        span {
            font-weight: 500;
        }
        font-family: Lato;
        font-weight: 500;
        font-size: 12px;
        line-height: 150%;
        color: #555C74;
        text-align: left;
    }
}

.project-dot {
    width: 24px;
    height: 24px;
    border-radius: 50px;
    background: #F88E8E;
}

.viewall {
    cursor: pointer;
    color: #0033EA;
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
    text-align: center;
    text-transform: capitalize;
    margin-top: 20px;
}

.chart-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
}
.duration-button {
    text-align: left;
    margin-top: 30px;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        color: #2B3352;
        background: transparent;
        box-shadow: none;
        outline: 0;
    }
}
.report-btns {
    margin-top: 30px;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        box-shadow: none;
        outline: 0;
    }
    .report {
        color: #333333;
        border: 1px solid #4A4A4A;
        margin-right: 10px;
    }
    .request {
        background: #00155F;
        color: #ffffff;
    }
}
.active-duration {
    background: #E8E8E8 !important;
}

.chart-spans {
    span:first-child {
        padding-right: 10px;
    }
    font-family: Lato;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #555C74;
    .light-span {
        font-weight: 400;
    }
}

// carousel start here
.inner-carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: auto;
    overflow: hidden;
}
.inner-slider {
   display: flex;
   transition: transform 0.5s ease;
}
.property-list {
    min-width: 100%;
    box-sizing: border-box;
    position: relative;
    h6, p, h5 {
        font-family: Lato;
        font-size: 14px;
        line-height: 21px;
        text-align: left;
        color: #2B3352;
    }
    h6 {
        font-weight: 600;
    }
    p {
        font-weight: 400;
        color: $asheGrey;
        margin-bottom: 10px !important;
    }
    h5 {
        font-weight: 400;
        text-align: justified;
        color: $primary;
        span {
            font-weight: 600;
        }
    }
}
.sliderImage {
    position: absolute;
    width: 100%;
}
.image-topBtn {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    button {
        outline: 0;
        box-shadow: none;
    }
    .relet {
        background: #000A2F;
        color: #ffffff;
        border-radius: 50px;
        font-family: Lato;
        font-weight: 500;
        font-size: 10px;
        min-height: 20px;
        height: 100%;
    }
    .seeall {
        background: #ffffff;
        color: #0033EA;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        min-height: 32px;
        height: 100%;
    }
}
.slide-button {
    text-align: center;
    button {
        background: blue;
        width: 8px;
        height: 8px;
        border-radius: 50px;
        padding: inherit;
        margin: 0 5px;
        outline: 0;
        box-shadow: none;
    }
}

.active-slide {
    border: 4px solid $primary;
    padding: 3px !important;
    background: $white !important;
}
// Carousel ends here

a {
    color: inherit !important;
}

// Fund project modal begins
// .fundmodalContent {
//   border-radius: 20px;
//   input,
//   select {
//     border: 1px solid #d2d3d3;
//     border-radius: 6px;
//     height: 45px;
//     box-shadow: none;
//     outline: 0;
//     // color: #b1b2b2;
//     color: $black;
//     font-size: 15px;
//     margin-bottom: 25px;
//     font-family: Gotham;
//   }
// }

.transferSafeBalance {
  font-family: Gotham;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #262626;
  text-align: left;
  padding-top: 10px;
  span {
    color: $primary;
  }
}

.transfer-btn {
  button {
    box-shadow: none;
    outline: 0;
    background: $primary;
    color: $secondary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    height: 45px;
  }
}


.closeFundProject {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  align-items: baseline;
  background: #efefef;
  h6 {
    font-family: Gotham;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 30px;
    color: $black;
  }
  small {
    font-family: Gotham;
    padding-left: 1px;
    text-align: center;
    background: #c4c4c4;
    color: $black;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.input_label {
  display: flex;
  font-family: Gotham;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  // line-height: 15px;
  color: $black;
}

// Fund project modal ends


.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

.withdrawal-header {
    // margin-top: 10px;
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #1F2937;

}

.modal-header  {
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}

.modal-header {
    text-align: left;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        color: #374151;
    }
}

.sheltaPrimaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}


.modal-top {
    font-family: Lato;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    color: #1F2937;

}

.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

.selected-check {
    border: 2px solid #1FC16B;
    color: #1FC16B;
    padding: 2px;
    border-radius: 4px;
    position: absolute;
    top: -17px;
    right: -17px;
    // i::before {
    //     color: #1FC16B;
    // }
}

.bank-select-gtb {
    border: 1px solid #E04826;
    border-radius: 4px;
    padding: 4px;
    margin-right: 25px;
    position: relative;
    cursor: pointer;
    img {
        width: 19.1px;
    }
    span {
        font-size: 10px;
        color: #E04826;
        padding: 0 4px;
    }
}

.bank-select-fbn {
    position: relative;
    border: 1px solid #162D4C;
    border-radius: 4px;
    padding: 4px;
    margin-right: 5px;
    cursor: pointer;
    img {
        width: 19.1px;
    }
    span {
        font-size: 10px;
        color: #374151;
        padding: 0 4px;
    }
}

.upgrade-label {
    font-family: Lato;
    font-weight: 500;
    // font-style: Medium;
    font-size: 14px;
    line-height: 150%;
    color: #777777;
    display: flex;
}

.activeBank {
    background: #D2D2D2 !important;
}

.bank-wrap {
    display: flex;
    margin-top: 18px;
}

// Empty state
.empty-state {
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 13.95px;
        line-height: 21.7px;
        letter-spacing: 0%;
        text-align: center;
        color: #777777;

    }
}
// empty state

.dropdown-menu {
  left: auto !important;
  right: 0 !important;
  transform: none !important;
}

@media only screen and (max-width: 599px) {
    .chart-spans {
        span:first-child {
            padding-right: 0px;
        }
    }
    .headerss {
        // display: block;
        // button {
        //     margin-top: 30px;
        // }
        h6 {
            display: none;
        }
    }
    .chart-buttons {
        display: block;

    }
    .report-btns {
        .report {
            width: 50%;
        }
        .request {
            width: 46%;
        }
    }
    .bank-wrap {
        margin-bottom: 20px;
    }

    .existing_prop_btn {
    button {
      line-height: 20px;
      img {
        padding-right: 10px;
      }
    }
  }
  .top_bar_payrent {
    margin-bottom: 18px;
  }
  .add_prop_rentfinancing_btn {
    display: flex;
    justify-content: center;
    button {
      line-height: 20px;
      img {
        padding-right: 7px;
        padding-left: 0px;
      }
    }
  }

  .top-option {
    margin-bottom: 1rem;
  }
}


@media only screen and (min-width: 481px) and (max-width: 1024px) {
  /* CSS rules for tablet screens only go here */
  .top_bar_payrent {
    margin-bottom: 18px;
    display: none;
  }
}

@media (min-width: 600px) {
  /* Styles apply when screen is 600px and above */
  // .top_bar_payrent {
  //   margin-bottom: 18px;
  //   display: none;
  // }
  .add_prop_rentfinancing_btn {
    display: flex;
    justify-content: center;
    button {
      line-height: 20px;
      img {
        padding-right: 7px;
        padding-left: 0px;
      }
    }
  }
}


// Countdown for guarantee rent starts
.notifications-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: 1.25rem;
//   width: 100% !important;
  max-width: 1200px;
//   margin: 0 auto;
}

@media screen and (min-width: 992px) {
  .notifications-grid {
    flex-direction: row !important;
    flex-wrap: wrap !important;
  }
  .rental-card {
    flex: 1 1 calc(33.333% - 0.85rem) !important;
    max-width: calc(33.333% - 0.85rem) !important;
  }
}

.rental-card {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  border: 1px solid #e0f2fe;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
}

/* Red-tinted styling states when timeline drops under 24 hours */
.rental-card.urgent-card {
  background: linear-gradient(135deg, #fef2f2 0%, #ffffff 100%);
  border-color: #fee2e2;
}

.progress-wrapper {
  position: relative;
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.progress-ring__bar {
  transform: rotate(-90deg);
  transform-origin: 36px 36px;
  transition: stroke-dashoffset 0.5s ease;
}

/* Color indicator turns red on urgency */
.progress-ring__bar.bar-urgent {
  stroke: #ef4444;
}

.counter-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.days-number {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
}

.days-label {
  font-size: 0.65rem;
  color: #64748b;
  margin-top: 2px;
  text-transform: lowercase;
}

.card-content {
  flex-grow: 1;
  padding: 0 1.25rem;
  min-width: 0;
}

.card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.25rem 0;
  text-align: left;
}

.card-address {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.card-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  height: 72px;
  flex-shrink: 0;
}

.close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.status-percentage {
  font-size: 0.95rem;
  font-weight: 600;
  color: #22c55e;
}
// Countdown for guarantee rent ends
</style>